import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [debugUrl, setDebugUrl] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      // Dev fallback while Resend email is not yet wired up
      if (data?.debug_reset_url) setDebugUrl(data.debug_reset_url);
    } catch (e2) {
      toast.error(formatApiErrorDetail(e2.response?.data?.detail) || "Could not send reset link");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#5F6C60] text-center">Forgot your password?</div>
      <h1 className="font-serif-display text-4xl tracking-tight text-center mt-2">Reset it</h1>
      <p className="text-sm text-center text-[#5F6C60] mt-3">Enter your email and we'll send a one-time reset link.</p>

      {sent ? (
        <div data-testid="forgot-sent" className="mt-10 bg-white p-8 rounded-2xl border border-[#E8E2D6] text-center space-y-4">
          <p className="text-sm text-[#2C352D]">
            If an account exists for <span className="font-semibold">{email}</span>, a reset link has been sent.
            Check your inbox.
          </p>
          {debugUrl && (
            <div className="text-xs text-[#5F6C60] bg-[#F9F7F3] border border-dashed border-[#E8E2D6] rounded-xl p-3 break-all">
              <div className="font-bold uppercase tracking-wider mb-1">Dev mode link:</div>
              <Link data-testid="forgot-debug-link" to={debugUrl} className="text-[#D97757] hover:underline">{debugUrl}</Link>
            </div>
          )}
          <p className="text-sm"><Link to="/login" className="text-[#D97757] hover:underline">Back to sign in</Link></p>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-10 bg-white p-8 rounded-2xl border border-[#E8E2D6] space-y-5">
          <div>
            <Label htmlFor="email" className="text-xs font-bold uppercase tracking-[0.15em]">Email</Label>
            <Input data-testid="forgot-email" id="email" type="email" required value={email} onChange={e=>setEmail(e.target.value)} className="mt-2 bg-[#F9F7F3] border-[#E8E2D6] rounded-xl h-12" />
          </div>
          <Button data-testid="forgot-submit" disabled={loading} type="submit" className="w-full h-12 rounded-full bg-[#D97757] hover:bg-[#C26243] text-white">{loading ? "Sending…" : "Send reset link"}</Button>
          <p className="text-sm text-center text-[#5F6C60]">Remembered it? <Link to="/login" className="text-[#D97757] hover:underline">Sign in</Link></p>
        </form>
      )}
    </div>
  );
}
